import { LoyaltyRangesGridView } from '~/components/loyalty/ranges';
import { PageContainer } from '~/components/page-container';

export function LoyaltyRanges() {
	return (
		<PageContainer>
			<LoyaltyRangesGridView />
		</PageContainer>
	);
}
